import { Box } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { AppTooltip } from '../common/AppTooltip';

interface QuestionLabelProps {
  label: string;
  helpText?: string | null;
}

export function QuestionLabel({ label, helpText }: Readonly<QuestionLabelProps>) {
  const trimmedHelp = helpText?.trim();
  if (!trimmedHelp) {
    return <>{label}</>;
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'flex-start',
        gap: 6,
        maxWidth: '100%',
      }}
    >
      <Box component="span" sx={{ whiteSpace: 'normal' }}>
        {label}
      </Box>
      <AppTooltip
        label={trimmedHelp}
        maxWidth={340}
        events={{ hover: true, focus: true, touch: true }}
        openDelay={100}
        withinPortal
      >
        <Box
          component="span"
          tabIndex={0}
          aria-label="More information about this question"
          sx={{
            display: 'inline-flex',
            color: 'var(--mantine-color-dimmed)',
            cursor: 'help',
            flexShrink: 0,
            marginTop: 2,
          }}
        >
          <IconInfoCircle size={16} stroke={1.75} />
        </Box>
      </AppTooltip>
    </Box>
  );
}
